import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, HomeParkingFee, HomeTopUpModel, MyAddressAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { ParkingCardInfo, StatusAPIResponse } from "../../../models/information.model";
import { ObjectFeeResponse } from "../../../models/parking.model";
import { CityParkingDiscountByCodeResponse } from "../../../models/discount.model";
import { CityParkingAccountTopUp, CreateOrderTopupPayload, RetCreateOrderTopup, TopupTransactionHistory } from "../../../models/topUpAccount.model";
import { PaymentTopupMemberPayload, PaymentTopupMemberResponse, PaymentTopupParkingPayload, PaymentTopupParkingResponse, PaymentTopupPenaltyPayload } from "../../../models/payment.model";

@Injectable({
  providedIn: 'root',
})

export class ApiTopUpService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiMethods: ApiMethodService,
  ) { }

  getHomeTopUp(uid: string, token: string) {
    return this.apiMethods.request<HomeTopUpModel>(
      '/Cityparking/GetHomeInfo',
      'GET',
      this.tokenUrl,
      {
        params: { uid: uid },
        isConsoleLog: true,
        headerOnly: false,
        labelLog: 'GetHomeTopUp',
      },
    );
  }

  /**
   * Zone 1B fee refresh (Taiwan pricing) — call after GetHomeInfo when isFeeReady=false
   */
  getHomeParkingFees(uid: string) {
    return this.apiMethods.request<HomeParkingFee[]>(
      '/Cityparking/GetHomeParkingFees',
      'GET',
      this.tokenUrl,
      {
        params: { uid: uid },
        isConsoleLog: true,
        headerOnly: false,
        labelLog: 'GetHomeParkingFees',
      },
    );
  }

  getTopUpAccount(
    uid: string,
    token: string,
  ): Observable<CityParkingAccountTopUp> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const params = new HttpParams().set('Uid', uid);
    return this.http.get<CityParkingAccountTopUp>(
      this.tokenUrl + '/TopUp/GetTopupAccount',
      { headers, params },
    );
  }

  createOrderTopup(
    body: CreateOrderTopupPayload,
    token: string,
  ): Observable<RetCreateOrderTopup> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<RetCreateOrderTopup>(
      this.tokenUrl + '/TopUp/CreateOrderQR',
      body,
      { headers },
    );
  }

  checkPaymentTopup(
    uid: string,
    token: string,
  ): Observable<CityParkingAccountTopUp> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const params = new HttpParams().set('Uid', uid);
    return this.http.get<CityParkingAccountTopUp>(
      this.tokenUrl + '/TopUp/CheckPaymentTopup',
      { headers, params },
    );
  }

  getTopupTransactionHistory(uid: string, topupNumber: string, token: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const params = new HttpParams()
      .set('Uid', uid)
      .set('TopupNumber', topupNumber);

    console.log("getTopupTransactionHistory", headers, params)
    return this.http.get<TopupTransactionHistory[]>(
      this.tokenUrl + '/TopUp/GetTopupTransactionHistory',
      { headers, params },
    );
  }

  getTopupBalance(uid: string, token: string): Observable<number> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const params = new HttpParams().set('Uid', uid);
    return this.http.get<number>(this.tokenUrl + '/TopUp/GetTopupBalance', {
      headers,
      params,
    });
  }


  sentApiPaymentTopupParking(
    payload: PaymentTopupParkingPayload,
    token: string,
  ): Observable<PaymentTopupParkingResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    console.log('Sent Api Payment Topup Parking', headers, payload);

    return this.http.post<PaymentTopupParkingResponse>(
      this.tokenUrl + '/TopUp/PaymentParkingByTopup',
      payload,
      {
        headers,
      },
    );
  }

  sentApiPaymentTopupPenalty(
    payload: PaymentTopupPenaltyPayload,
    token: string,
  ): Observable<PaymentTopupParkingResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    console.log('Sent Api Payment Topup Parking', headers, payload);

    return this.http.post<PaymentTopupParkingResponse>(
      this.tokenUrl + '/TopUp/PaymentPenaltyByTopup',
      payload,
      {
        headers,
      },
    );
  }

  sentApiPaymentTopupMember(
    payload: PaymentTopupMemberPayload,
    token: string,
  ): Observable<PaymentTopupMemberResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    console.log('Sent Api Payment Topup Member', headers, payload);

    return this.http.post<PaymentTopupMemberResponse>(
      this.tokenUrl + '/TopUp/PaymentMemberByTopup',
      payload,
      {
        headers,
      },
    );
  }
}